(function($) {

	var loaded = false;

	$(document).on("zp-ready", function () {
		zp_init();
	});

	function zp_init()  {
		//zp_unload();
		var video = $(".zp_video");

		if(video.length > 0) {
			video.each(function(index, element) {
				var ele = $(element);
				if(!ele.hasClass("zp-loaded")) {
					ele.addClass("zp-loaded");
					var link = ele.find(".link");
					if (link.length > 0) {
						if ($('html').hasClass('zp-touch')) {

							var video = $(this).closest(".zp_video");

							var frame = video.find(".video-frame");
							frame.attr("src", video.attr("data-video"));

						}
						link.on("click", zp_play);
					}
					if(ele.attr("data-autoplay") == "1") {
						link.click();
					}
				}
				//$(".zp_video[data-autoplay='1'] .link").click();
			});
		}

		if(!loaded) {
			$(document).on("zp-unload", zp_unload);
			loaded = true;
		}
	}

	function zp_play(e) {
		e.preventDefault();

		var video = $(this).closest(".zp_video");

		video.addClass("play");
		var frame = video.find(".video-frame");
		frame.attr("src", video.attr("data-video"));

	}

	function zp_unload() {
		var video = $(".zp_video");
		if(video.length > 0) {
			var link = video.find(".link");
			if(link.length > 0) {
				link.off("click", zp_play);
			}
			//$(document).off("zp-unload", zp_unload);
		}
	}

})(jQuery);